import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { when } from 'mobx'
import { inject, observer } from 'mobx-react'
import Tooltip from 'react-tooltip'
import Header from './base/components/Header'

@inject('auth') @observer
class AppContainer extends Component {

  static propTypes = {
    auth: PropTypes.object.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    router: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  }

  componentWillMount() {
    // once the user logged in, redirect him to the main page
    this.handler = when(
      'Redirect once user logged in',
      () => this.props.auth.isLoggedIn,
      () => {
        if (window.location.pathname.indexOf('login') > -1) {
          this.props.router.push('/')
        }
      }
    )
  }

  render() {
    const devtools = process.env.NODE_ENV === 'development'
      ? null // <DevTools />
      : null

    if (!this.props.auth.isLoggedIn) {
      return this.props.children
    }

    return (
      <div className="app">

        <Tooltip
          className="tooltip"
          // multiline
          html
          place="right"
          type="info"
          effect="solid"
        />

        {devtools}

        <Header />

        {this.props.children}

      </div>
    )
  }
}

const AppContainerWithRouter = withRouter(AppContainer)

export { AppContainerWithRouter as default }



// WEBPACK FOOTER //
// ./src/AppContainer.js